module.exports = __webpack_public_path__ + "static/img/yeswecan0012.7f18df8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/yeswecan0012.png
// module id = 578
// module chunks = 1